export default __webpack_public_path__ + "static/plan-75b4fb89e6c857d8ce91d1670864402e.png";